document.addEventListener('DOMContentLoaded', () => {
    const form      = document.querySelector<HTMLFormElement>('form');
    const submitBtn = document.querySelector<HTMLButtonElement>('button[type="submit"]');

    form?.addEventListener('submit', () => {
        if (!submitBtn) return;
        submitBtn.disabled  = true;
        submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Entrando...';
    });
});
